/* Common.ts */

export enum Insights {
  FULL_SAMPLE = "Full sample",
}
